const menuDropDown = () => {

	let menu = document.querySelector('.header .menu .fence'),
		line = document.querySelector('.header .menu .fence .line1'),
		dropdown = document.querySelector('.header .menu .dropdown'),
		linksMenu = document.querySelectorAll('.header .menu .dropdown li a'),
		bodyBg = document.querySelector('body');


	let mainURL_EN = document.location.protocol + '//' + document.location.host + '/',
		mainURL_RU = document.location.protocol + '//' + document.location.host + '/ru';

	//если находимся на главной странице
	if (document.location.href == mainURL_EN || document.location.href == mainURL_RU) {

		
		function showMenu() {

			line.classList.add('rotate');
			dropdown.classList.remove('hide');
			dropdown.classList.add('fadeIn');

			menu.removeEventListener("mouseover", showMenu);
		}

		function hideMenu() {
			line.classList.remove('rotate');
			dropdown.classList.remove('fadeIn');
			dropdown.classList.add('hide');

			menu.addEventListener("mouseover", showMenu);
		}

		menu.addEventListener("mouseover", showMenu);
		dropdown.addEventListener("mouseover", showMenu);
		menu.addEventListener("mouseout", hideMenu);
		dropdown.addEventListener("mouseout", hideMenu);

	} else { //если не на главной 			
		
		dropdown.classList.remove('hide');
		line.classList.add('rotate');

		linksMenu.forEach(function(item, index, array) {
			if (item.href == document.location.href) {
				item.classList.add('selected');				
			}
			if (document.location.href.split('/').indexOf('exhibitions') > 0){
				if(item.href.split('/').indexOf('exhibitions') > 0){
					item.classList.add('selected');
				}
			}			
		});
	}
}
export default menuDropDown;